module.exports = __webpack_public_path__ + "static/media/museum.beb303a1.png";